import { inject } from '@angular/core';
import { PermissionService } from '../services/permission/permission.service';
import { AuthService } from '../services/auth/auth.service';
import { PermissionEnum, ResourceEnum } from '../../../environments/shared-environment/permission';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

type GuardResult = boolean | Promise<boolean>;

export const isAuthenticated = (): GuardResult => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn())
    return router.navigate([environment.configs.unauthenticatedRoute], { replaceUrl: true }).then(() => false);

  return true;
};

export const notAuthenticated = (): boolean => {
  const authService = inject(AuthService);

  if (!authService.isLoggedIn())
    return true;

  return false;
};

export const canLogin = (): GuardResult => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn())
    return router.navigate([environment.configs.authenticatedRoute], { replaceUrl: true }).then(() => false);

  return true;
};

export const hasPermission = (resource: ResourceEnum, permission: PermissionEnum) => (): GuardResult => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (permissionService.has(resource, permission)) {
    return true;
  }

  return router.navigate([environment.configs.authenticatedRoute], { replaceUrl: true }).then(() => false);
};

export const canActivateUser = hasPermission(ResourceEnum.USERS, PermissionEnum.VIEW);
export const canActivateCourses = hasPermission(ResourceEnum.COURSES, PermissionEnum.VIEW);
export const canActivateTracks = hasPermission(ResourceEnum.TRACKS, PermissionEnum.VIEW);
export const canActivateProfile = hasPermission(ResourceEnum.PROFILE, PermissionEnum.VIEW);
